<template>
  <div class="Ctrl-parameter-log">
    <el-row>
      <el-col>
        <h2>パラメータログ</h2>
      </el-col>
    </el-row>
    <ParameterPassingLogList :type="'ctrl'" />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import ParameterPassingLogList from "@/components/Tools02/ParameterLog/ParameterPassingLogList.vue";

export default {
  components: {
    ParameterPassingLogList,
  },
  props: {},
  data() {
    return {};
  },
  computed: {
    ...mapGetters(["rt", "tool"]),
  },
  watch: {},
  methods: {},
};
</script>

<style lang="scss" scoped>
</style>
